export enum DashboardTileTypeEnum {
    SingleGroupTileDetailPerRow = 1,
    SingleGroupTileDetailPerTile = 2,
    MultipleGroupTileDetailPerRow = 3,
    MultipleGroupTileDetailPerTile = 4,
    SingleDonutGraphTileDetailPerRow = 5,
    SingleDonutGraphTileDetailPerTile = 6,
    MultipleDonutGraphTileDetailsPerRow = 7,
    MultipleDonutGraphTileDetailsPerTile = 8,
}
